import { Property, PropertyLocation } from "types";
import { formatPrice } from "utils";
import { hash } from "utils/hash";

const getPropertyName = ({ department }: Pick<Property, "department">) => {
  return `Campo en ${department}`;
};

type PricePerHaProps = Pick<Property, "totalPrice" | "ha">;

const getPropertyPricePerHa = ({ totalPrice, ha }: PricePerHaProps) => {
  return Math.floor(totalPrice / ha);
};

const formatPropertyPricePerHa = (property: PricePerHaProps) => {
  return formatPrice(getPropertyPricePerHa(property));
};

const hashProperty = (property: Partial<Property>) => {
  return hash(`${property.department}${property.id}`).toString();
};

const locationSearchModel = (
  location: PropertyLocation
): Record<string, string> => {
  return { access: location.access };
};

const propertySearchModel = (property: Property): Record<string, string> => {
  return {
    department: property.department,
    description: property.description.join(" "),
    ...locationSearchModel(property.location),
  };
};

export {
  getPropertyName,
  getPropertyPricePerHa,
  formatPropertyPricePerHa,
  hashProperty,
  propertySearchModel,
};
